import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { useOpinionCommentList } from "utils/clientAPIs/debate";
import CommentInput from "./Input";
import Button from "components/common/buttons/buttons";
import { createContext, useContext, useEffect, useState } from "react";
import { useDebateContext } from "contexts/DebateContext";
import { useRouter } from "next/router";
import { useParams } from "next/navigation";
import MainCommentTemplete from "./MainCommentTemplete";
import { useDebateCleanMode } from "states/debateState";
import { useDiscussIdContext } from "contexts/DiscussIdContext";

interface MainCommentListContextType {
  allComments: any;
  setAllComments: (comments: any) => void;
  parentUser: string;
}

const MainCommentListContext = createContext<MainCommentListContextType | null>(
  null
);

function MainCommentList({
  opinionId,
  parentUser,
  commentCount,
}: {
  opinionId: number;
  parentUser: string;
  commentCount: number;
}) {
  const { discussId, slug } = useDiscussIdContext();
  const router = useRouter();
  const { check } = require("korcen");
  const isCleanMode = useDebateCleanMode();
  const { isCommentDisabled, registerMutate, tempRemoveTopRef } =
    useDebateContext();
  const [allComments, setAllComments] = useState<CommentItem[]>([]);
  const [isEnd, setIsEnd] = useState(false);
  const lastAt = undefined; // 댓글 페이지 네이션 기능 제거함

  const [comments, isLoading, mutate, isValidating] = useOpinionCommentList(
    opinionId,
    lastAt
  );

  // 새로 가져온 데이터 처리
  // 신규 댓글을 작성 -> Mutate 하지 않고 임시로 댓글 목록의 가장 위에 위치 (setAllComments) -> 해당 댓글을 삭제해도 allComments 변수에 남아있는 문제 해결
  // 신규 댓글을 바로 삭제 -> tempRemoveTopRef 등록 -> triggerMuate 실행 -> isValidating 변수가 변경 -> allComments 변수에 있는 댓글 중 tempRemoveTopRef 에 등록된 댓글을 제외한 댓글을 새로운 댓글 목록으로 업데이트
  useEffect(() => {
    if (!isValidating) {
      const removeIds = Object.keys(tempRemoveTopRef.current);
      const newComments = comments?.filter(
        (comment: CommentItem) =>
          !removeIds.includes(comment.comment_id.toString())
      );
      const filteredComments = newComments?.map((comment: CommentItem) => {
        const isCensored = comment?.description
          ? check(comment?.description)
          : false;
        return {
          ...comment,
          isCensored,
        };
      });
      setAllComments(filteredComments);
    }
  }, [isValidating]);

  // 댓글 데이터 업데이트
  useEffect(() => {
    if (mutate) registerMutate(opinionId, mutate);
  }, [mutate, opinionId]);

  const handleShowAll = () => {
    if (!discussId || !opinionId) return;
    router.push(
      `/discuss/${
        slug ? `${slug}-${discussId}` : discussId
      }/opinion/${opinionId}`
    );
    return;
  };

  return (
    <MainCommentListContext.Provider
      value={{ allComments, setAllComments, parentUser: parentUser || "" }}
    >
      <div
        className={`flex flex-col ${
          allComments?.length
            ? "gap-2"
            : isCommentDisabled && allComments?.length === 0
            ? "hidden"
            : ""
        }`}
      >
        {!isCommentDisabled && (
          <CommentInput
            type="comment"
            mode="input"
            opinionId={opinionId}
            setAllComments={setAllComments}
          />
        )}
        {isLoading && !allComments?.length ? null : (
          <>
            {allComments?.length > 0
              ? allComments?.map((comment: CommentItem, index: number) => (
                  <MainCommentTemplete
                    key={index}
                    data={comment}
                    // isOwnerComment={parentUser === comment.email}
                  />
                ))
              : null}
            {commentCount > 5 && (
              <div
                className="w-full items-center justify-center flex cursor-pointer"
                onClick={handleShowAll}
                data-test-id="show-all-button"
              >
                <Button type="tertiary" size="sm" text="전체 보기" />
              </div>
            )}
          </>
        )}
      </div>
    </MainCommentListContext.Provider>
  );
}

export const useMainCommentListContext = () => {
  const context = useContext(MainCommentListContext);
  try {
    if (!context)
      throw new Error(
        "useMainCommentListContext must be used within MainCommentListContext"
      );
    return context;
  } catch (error) {
    return null;
  }
};

export default MainCommentList;

// const handleLoadMore = useCallback(() => {
//   if (isLoading || isEnd) return;
//   // lastAt 상태가 이미 바뀌면 useSWR 내부에서 자동 요청됨
//   setLastAt(allComments[allComments.length - 1]?.created_at);
// }, [allComments]);

// const updateComments = (
//   allComments: CommentItem[],
//   newComments: CommentItem[]
// ) => {
//   if (!lastAt) return;

//   if (comments?.length > 0) {
//     // 중복 제거 후 업데이트
//     // setAllComments((prev) => {
//     //   const existingIds = new Set(prev.map((c) => c.comment_id));
//     //   const filteredNew = newComments.filter(
//     //     (c: CommentItem) => !existingIds.has(c.comment_id)
//     //   );
//     //   console.log("filteredNew", filteredNew);
//     //   return [...prev, ...filteredNew];
//     // });
//     console.log("allComments", allComments);
//     console.log("newComments", newComments);

//     setAllComments([...allComments, ...newComments]);

//     // // 다음 요청을 위한 lastAt 업데이트
//     // const lastItem = newComments[newComments.length - 1];
//     // setLastAt(lastItem.created_at);

//     // 만약 받아온 데이터 수가 0개면 더 이상 로드할 게 없음
//     if (newComments.length < 5) {
//       setIsEnd(true);
//     }
//   } else setIsEnd(true);
// };

// useEffect(() => {
//   if (isLoading) return;
//   updateComments(allComments, comments);
// }, [isLoading]);
